import useStyles from "./Loader.styles";

const Loader = () => {
  const { classes } = useStyles();
  return <div className={classes.loader} />;
};

export default Loader;
